import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setSideNavState } from '../../../redux/layout/layoutActions';

const useContentSidenav = () => {
  const { sideNavExpanded } = useSelector(state => state.pro.layout);
  const dispatch = useDispatch();
  const onSideNavSetState = useCallback(
    state => dispatch(setSideNavState(state)),
    [dispatch],
  );
  const onSideNavToggle = useCallback(
    () => onSideNavSetState(!sideNavExpanded),
    [],
  );
  const onSideNavCollapse = useCallback(() => onSideNavSetState(false), []);

  return {
    sideNavExpanded,
    onSideNavSetState,
    onSideNavCollapse,
    onSideNavToggle,
  };
};

export default useContentSidenav;
